
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { cn } from '@/lib/utils';
import { useTheme } from '@/contexts/ThemeContext';

interface NavLinksProps {
  mobile?: boolean;
  onLinkClick?: () => void;
}

const NavLinks: React.FC<NavLinksProps> = ({ mobile = false, onLinkClick = () => {} }) => {
  const { currentUser } = useAuth();
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  // Define complete navigation links for both desktop and mobile
  const links = [
    { text: 'Home', to: '/' },
    { text: 'About', to: '/about' },
    { text: 'AURA', to: '/points' },
  ];

  // Choose which links to display based on authentication status
  const displayLinks = links;

  return (
    <nav className={cn(
      "flex items-center",
      mobile ? "flex-col w-full space-y-2" : "space-x-1 sm:space-x-4"
    )}>
      {displayLinks.map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          onClick={onLinkClick}
          className={({ isActive }) =>
            cn(
              mobile ? "w-full text-center py-3" : "px-3 py-2 rounded-md",
              "text-sm font-medium transition-colors rounded-md",
              isActive
                ? isDark
                  ? "bg-[#292D67] text-white"
                  : "bg-blue-100 text-blue-800"
                : isDark
                ? "text-slate-200 hover:bg-[#1D203A]"
                : "text-slate-800 hover:bg-slate-100"
            )
          }
        >
          {link.text}
        </NavLink>
      ))}
    </nav>
  );
};

export default NavLinks;
